import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: getApiHostWithoutEnv('push2api'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class EMHqApi {
  getStokeCodelist(FCODE) {
    return this.GET('/api/qt/ulist.np/get', {
      fltt: 2,
      secids: FCODE,
      fields: 'f1,f2,f3,f4,f12,f13,f14,f29,f292',
      ut: '94dd9fba6f4581ffc558a7b1a7c2b8a3',
      invt: 2,
    });
  }

  getStockOversea(FCODE) {
    return this.GET('/api/qt/ulist.np/get', {
      fltt: 2,
      secids: FCODE,
      fields: 'f1,f2,f3,f4,f12,f13,f14,f29,f292',
      ut: '94dd9fba6f4581ffc558a7b1a7c2b8a3',
      invt: 2,
    });
  }
}
export default new EMHqApi();
